import { render, staticRenderFns } from "./performanceList.vue?vue&type=template&id=26bfa647&scoped=true"
import script from "./performanceList.vue?vue&type=script&lang=js"
export * from "./performanceList.vue?vue&type=script&lang=js"
import style0 from "./performanceList.vue?vue&type=style&index=0&id=26bfa647&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bfa647",
  null
  
)

export default component.exports